import './App.scss';
import { Outlet, useLoaderData } from 'react-router';
import { lazy, Suspense, useEffect, useState } from 'react';
import { useInternetConnectionAlert } from './hooks/connection.hooks';
import DocumentHead from './themes/document-head';
import { useAppDispatch } from './store/hooks';
import { setFeatureFlags } from './store/slices/feature-flags';
import { type FeatureFlagMap } from './store/slices/feature-flags/types';
import { initTelemetry } from './utils/telemetry';
import { AppEnv } from './utils/env';

const Alerts = lazy(() => import('@ui/alert/alert.client'));

export default function App(): JSX.Element {
  const { env, featureFlags } = useLoaderData<{ env: AppEnv; featureFlags: FeatureFlagMap }>();
  const dispatch = useAppDispatch();

  const [mounted, setMounted] = useState(false);

  useInternetConnectionAlert();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (featureFlags) {
      dispatch(setFeatureFlags(featureFlags));
    }
  }, [dispatch, featureFlags]);

  useEffect(() => {
    initTelemetry();
  }, []);

  return (
    <>
      <script suppressHydrationWarning dangerouslySetInnerHTML={{ __html: `window.__env=${JSON.stringify(env)}` }} />
      <DocumentHead />
      <Outlet />
      {mounted && (
        <Suspense fallback={null}>
          <Alerts />
        </Suspense>
      )}
    </>
  );
}
